import { makeStyles } from '@material-ui/core/styles';

const ButtonsUseStyles = makeStyles(theme => ({
  Buttons: {
    backgroundColor: theme.palette.green,
    border: '2px solid',
    borderColor: theme.palette.white,
    cursor: 'pointer',
    margin: 0,
    minHeight: 40,
    minWidth: 'initial',
    padding: 0,
    transition: 'color 0.25s, box-shadow 0.25s',
    '&--color': {
      color: theme.palette.black,
      transition: 'color 0.25s',
      '&:hover': {
        color: theme.palette.white,
      },
    },
    '&--reject': {
      backgroundColor: theme.palette.error.main,
      '&:hover': {
        backgroundColor: theme.palette.error.main,
        boxShadow: '0 0 12px rgba(239, 68, 68, 0.3) !important',
      },
    },
    '&:hover, &__active': {
      color: theme.palette.white,
      backgroundColor: theme.palette.green,
      boxShadow: '0 0 12px rgba(6, 182, 212, 0.3) !important',
    },
  },
  ButtonsCircle: {
    borderRadius: '50%',
    height: '45px !important',
    width: '45px !important',
    '&--mid': {
      height: '30px !important',
      width: '30px !important',
      minHeight: 30,
      '& svg': {
        width: 20,
        height: 20,
      },
    },
    '&--small': {
      height: '25px !important',
      width: '25px !important',
      minHeight: 25,
      '& svg': {
        width: 15,
        height: 15,
      },
    },
    '&__transparent': {
      padding: '5px 0',
      backgroundColor: 'initial',
      minWidth: 'initial',
      transition: 'background-color 0.25s ease',
      '&:hover': {
        backgroundColor: theme.palette.green,
      },
      '&--active': {
        color: theme.palette.green,
      },
      '&--disable': {
        color: theme.palette.darkGrey,
        backgroundColor: `transparent !important`,
      },
    },
    '& svg': {
      width: 30,
      height: 30,
    },
    '&--background-color': {
      backgroundColor: 'initial',
    },
  },
  ButtonsRectangle: {
    borderRadius: 5,
    margin: '10px',
    marginLeft: '0px',
    padding: 10,
    minWidth: 60,
  },
  ButtonsClose: {
    position: 'absolute',
    top: 0,
    right: 0,
    '&--login-page': {
      top: 15,
      right: 15,
    },
  },
}));
export default ButtonsUseStyles;
